import React, { useState } from "react";
import UserSidebar from "./UserSidebar";

function Navbar() {
  const [fillColor, setFillColor] = useState("black");

  return (
    <div className="flex flex-row justify-center">
      <nav className="bg-white w-full z-20 top-0 start-0 border-b border-gray-200 mx-5 lg:mx-10 mt-5 rounded-lg shadow-xl">
        <div className="max-w-screen-xl flex flex-wrap items-center justify-between mx-auto p-4">
          <a
            href="/"
            className="flex items-center space-x-3 rtl:space-x-reverse transition-transform duration-300 hover:scale-105"
            onMouseEnter={() => setFillColor("#6F48E5")}
            onMouseLeave={() => setFillColor("black")}
          >
            <svg version="1.0" xmlns="http://www.w3.org/2000/svg"
 width="90" height="40" viewBox="700 1350 2550 1200"
 preserveAspectRatio="xMidYMid meet">

<g transform="translate(0.000000,4096.000000) scale(0.100000,-0.100000)"
fill={fillColor} stroke="none" style={{transition: "fill 0.3s ease-in-out"}}>
<path d="M14960 26025 c-8 -2 -82 -8 -165 -14 -82 -7 -206 -18 -275 -27 -294
-35 -449 -56 -511 -70 -37 -7 -82 -14 -100 -14 -19 -1 -63 -7 -99 -15 -36 -8
-80 -14 -99 -15 -18 0 -63 -6 -100 -14 -36 -8 -97 -20 -136 -26 -38 -6 -101
-18 -140 -25 -38 -7 -110 -20 -158 -29 -49 -9 -92 -18 -96 -21 -4 -2 -32 -9
-62 -14 -52 -10 -154 -34 -284 -67 -33 -9 -85 -22 -115 -30 -30 -7 -82 -20
-115 -28 -33 -8 -73 -19 -90 -24 -16 -6 -50 -15 -75 -22 -111 -27 -125 -32
-135 -39 -5 -5 -23 -11 -40 -14 -27 -4 -165 -52 -295 -101 -25 -10 -59 -22
-77 -27 -18 -5 -35 -14 -38 -19 -4 -6 -13 -10 -21 -10 -20 0 -198 -85 -267
-128 -198 -123 -431 -352 -680 -667 -29 -36 -136 -195 -241 -358 -137 -211
-353 -620 -416 -787 -7 -19 -21 -53 -30 -75 -9 -22 -32 -76 -49 -120 -18 -44
-39 -93 -47 -110 -7 -16 -23 -59 -35 -95 -12 -36 -28 -74 -35 -85 -8 -11 -14
-31 -14 -46 0 -15 -6 -32 -14 -38 -8 -6 -16 -24 -19 -39 -6 -33 -25 -88 -43
-124 -8 -14 -14 -36 -14 -48 0 -12 -5 -31 -11 -43 -7 -11 -18 -42 -25 -67 -7
-25 -23 -76 -34 -115 -12 -38 -25 -86 -30 -105 -4 -19 -13 -48 -18 -65 -12
-35 -34 -114 -57 -205 -9 -36 -23 -87 -30 -115 -25 -92 -68 -278 -86 -374 -5
-30 -12 -58 -15 -63 -5 -8 -14 -56 -45 -233 -6 -38 -18 -87 -25 -108 -8 -20
-14 -55 -14 -77 0 -21 -7 -65 -15 -97 -8 -31 -15 -78 -15 -104 0 -25 -7 -66
-15 -89 -8 -23 -15 -63 -15 -89 0 -25 -6 -77 -14 -116 -8 -38 -20 -133 -25
-210 -6 -77 -15 -192 -20 -255 -35 -395 -52 -1063 -32 -1255 6 -60 16 -189 21
-285 5 -96 12 -187 15 -201 3 -14 12 -99 20 -190 14 -164 26 -262 47 -394 6
-38 14 -97 18 -130 4 -33 12 -82 18 -110 39 -179 54 -241 75 -306 39 -119 142
-281 223 -347 71 -58 281 -142 357 -142 14 0 37 -4 52 -10 14 -5 94 -21 178
-34 408 -66 1060 -97 1357 -66 352 37 584 69 690 95 30 7 82 18 115 24 33 6
92 18 130 26 39 9 90 20 114 25 24 6 69 17 100 26 31 9 81 23 111 31 30 9 66
20 80 26 14 5 41 13 60 18 39 8 187 61 237 84 17 8 36 15 42 15 6 0 19 4 29 9
9 5 40 19 67 31 92 39 109 47 275 129 91 44 186 94 213 111 l47 30 1 188 c2
507 37 1497 58 1647 6 39 10 94 11 123 0 48 4 59 39 98 41 46 85 80 136 103
37 16 186 54 280 70 39 7 93 17 120 22 55 11 247 34 425 49 63 6 162 15 220
21 58 5 177 14 265 19 88 6 174 12 190 15 17 3 129 12 250 20 335 21 465 41
578 89 123 53 277 180 352 290 50 74 125 218 165 316 12 30 28 69 36 85 7 17
25 62 40 100 22 57 78 195 123 300 5 11 19 45 31 75 11 30 25 64 30 75 5 11
25 61 46 110 72 177 69 170 149 335 89 183 131 245 227 336 167 159 313 233
588 301 65 16 115 18 370 17 173 -1 326 -6 370 -13 41 -7 156 -16 255 -21 99
-5 198 -13 220 -19 22 -6 79 -11 126 -11 48 0 111 -5 140 -10 30 -6 129 -15
222 -20 92 -5 172 -12 178 -15 5 -4 79 -10 162 -15 84 -4 186 -13 227 -19 41
-6 134 -15 205 -21 218 -16 382 -29 560 -45 94 -8 197 -17 230 -19 33 -2 114
-9 180 -15 269 -24 367 -32 515 -42 85 -5 187 -14 225 -19 39 -6 144 -15 235
-21 91 -5 192 -14 225 -19 33 -4 107 -9 165 -9 58 -1 123 -6 145 -11 22 -6
103 -13 180 -15 77 -3 199 -12 270 -20 143 -16 332 -32 527 -45 71 -5 136 -11
145 -14 10 -2 86 -10 168 -16 216 -15 486 -39 590 -51 50 -6 169 -15 265 -20
96 -5 195 -14 220 -19 25 -5 83 -9 130 -10 47 0 117 -5 155 -10 39 -5 150 -14
247 -20 98 -5 215 -14 260 -20 46 -5 139 -15 208 -20 198 -16 352 -29 530 -45
91 -8 217 -17 280 -20 63 -3 135 -10 160 -15 25 -5 97 -10 160 -10 63 -1 142
-6 175 -11 33 -4 146 -13 250 -19 105 -6 263 -17 353 -25 90 -8 218 -15 285
-16 67 0 145 -4 172 -10 28 -5 174 -13 325 -19 151 -5 338 -14 415 -19 171
-11 1650 -19 1661 -8 4 4 4 10 1 13 -6 7 -192 24 -457 44 -74 5 -155 14 -180
20 -25 6 -97 14 -160 19 -148 12 -306 29 -395 41 -38 6 -131 17 -205 25 -226
25 -541 71 -590 85 -19 5 -55 10 -80 10 -25 0 -67 7 -94 15 -27 8 -70 15 -96
15 -26 0 -67 7 -90 15 -23 8 -56 15 -73 15 -17 0 -53 6 -81 14 -28 8 -73 20
-101 26 -187 41 -276 65 -303 79 -11 6 -30 11 -42 11 -12 0 -36 6 -53 13 -40
17 -96 37 -122 44 -93 24 -339 148 -480 241 -114 76 -337 290 -401 385 -70
105 -164 268 -164 285 0 9 -7 26 -15 36 -8 11 -15 26 -15 34 0 20 -43 112 -52
112 -13 0 -9 -67 6 -133 17 -71 35 -176 45 -262 4 -33 12 -78 18 -100 7 -22
19 -87 29 -145 9 -58 25 -142 35 -186 11 -45 19 -93 19 -107 0 -13 7 -44 15
-68 24 -68 17 -71 -155 -54 -80 8 -174 19 -210 24 -36 6 -90 11 -120 11 -30 0
-82 7 -115 15 -33 8 -89 15 -125 15 -36 0 -97 7 -135 15 -39 8 -104 15 -145
15 -41 0 -106 7 -145 15 -38 8 -96 15 -128 15 -31 0 -101 6 -155 14 -53 8
-142 17 -197 21 -55 3 -120 10 -145 16 -25 5 -88 13 -140 18 -91 8 -114 14
-205 50 -52 20 -198 105 -255 148 -56 43 -129 124 -163 183 -26 44 -57 133
-91 255 -24 84 -47 166 -57 195 -32 97 -17 132 49 112 20 -7 82 -17 137 -23
55 -6 103 -13 107 -15 3 -2 44 -8 90 -13 150 -17 313 -40 358 -50 25 -6 68
-11 95 -11 28 -1 68 -7 90 -15 22 -8 61 -15 87 -15 26 0 67 -7 92 -15 25 -9
75 -20 113 -25 37 -6 93 -14 123 -19 84 -14 162 -13 158 2 -3 6 -27 15 -54 18
-27 4 -62 14 -79 23 -16 9 -47 16 -68 16 -21 0 -54 7 -74 15 -19 8 -52 15 -73
15 -21 0 -57 7 -80 15 -23 8 -57 15 -75 15 -18 0 -52 7 -75 15 -23 8 -57 15
-76 15 -18 0 -45 5 -61 11 -15 7 -59 17 -98 25 -38 7 -92 17 -120 23 -27 7
-84 18 -125 27 -41 8 -100 21 -130 29 -30 7 -89 20 -130 29 -101 22 -241 53
-316 71 -33 8 -70 15 -81 15 -11 0 -37 7 -56 15 -20 8 -48 15 -63 15 -15 0
-50 6 -78 14 -28 8 -76 19 -106 26 -30 6 -71 14 -90 19 -19 5 -55 13 -80 19
-25 7 -90 21 -145 32 -55 12 -121 28 -146 36 -26 8 -64 14 -85 14 -22 1 -50 7
-64 15 -14 8 -42 14 -63 15 -21 0 -54 7 -74 15 -19 8 -49 15 -65 15 -16 0 -57
7 -91 15 -187 45 -235 55 -259 55 -14 0 -42 7 -61 15 -20 8 -50 15 -67 15 -17
0 -59 6 -93 14 -34 8 -87 20 -117 26 -30 7 -84 18 -120 26 -57 13 -143 29
-325 64 -27 5 -79 14 -115 21 -36 6 -90 17 -120 24 -57 14 -133 29 -233 45
-32 6 -66 14 -76 19 -9 5 -46 13 -81 17 -36 3 -73 11 -83 16 -10 5 -48 13 -85
18 -72 8 -159 24 -232 42 -25 6 -76 14 -115 18 -38 4 -90 12 -115 18 -55 13
-153 31 -238 43 -34 4 -82 15 -107 24 -25 8 -65 15 -89 15 -24 0 -63 7 -86 15
-23 8 -61 15 -84 15 -23 0 -68 7 -99 15 -32 8 -74 15 -94 15 -20 0 -62 6 -92
14 -57 14 -128 27 -281 51 -160 25 -225 36 -270 45 -25 6 -76 14 -115 19 -38
5 -83 14 -98 20 -16 6 -46 11 -69 11 -22 0 -70 7 -107 15 -69 15 -147 28 -291
50 -47 7 -101 18 -120 24 -19 6 -60 11 -90 11 -30 0 -73 7 -95 15 -22 8 -59
14 -82 15 -23 0 -68 7 -100 15 -31 8 -78 15 -104 15 -25 0 -68 7 -95 15 -27 8
-71 15 -98 15 -26 0 -74 7 -105 15 -31 8 -94 19 -141 24 -47 6 -101 15 -120
21 -19 5 -55 10 -80 10 -25 0 -76 6 -115 14 -38 8 -124 22 -190 31 -66 8 -145
20 -175 26 -30 6 -93 14 -140 19 -47 4 -92 11 -100 14 -14 5 -197 26 -410 47
-125 12 -306 2 -405 -23 -208 -52 -433 -200 -589 -387 -119 -142 -245 -349
-316 -516 -12 -27 -25 -59 -30 -70 -35 -80 -50 -120 -50 -134 0 -9 -5 -22 -11
-28 -6 -6 -14 -26 -19 -44 -5 -19 -19 -65 -32 -104 -14 -38 -34 -101 -46 -140
-12 -38 -28 -92 -37 -119 -8 -27 -15 -57 -15 -67 0 -9 -7 -30 -15 -45 -8 -16
-15 -42 -15 -59 -1 -16 -7 -41 -15 -55 -8 -14 -14 -42 -15 -63 0 -21 -4 -46
-10 -56 -10 -20 -37 -134 -80 -341 -7 -30 -18 -77 -26 -104 -8 -26 -14 -65
-14 -85 -1 -20 -7 -54 -15 -76 -8 -22 -15 -55 -15 -74 0 -19 -6 -57 -14 -85
-16 -57 -33 -153 -47 -266 -5 -41 -14 -88 -19 -105 -5 -16 -14 -64 -19 -105
-5 -41 -14 -109 -20 -150 -27 -181 -41 -270 -51 -335 -7 -38 -16 -112 -20
-163 -5 -51 -13 -114 -19 -140 -22 -99 -54 -369 -47 -389 6 -15 57 -18 72 -4
5 5 45 18 89 30 44 12 96 27 114 33 54 17 128 35 328 81 91 22 153 48 164 70
6 10 19 69 30 131 10 61 25 147 34 191 9 44 20 116 26 160 6 44 17 103 25 131
8 28 14 61 14 74 0 25 22 159 45 275 8 39 20 97 26 130 6 33 17 88 25 123 8
34 20 90 28 125 7 34 18 80 24 102 6 22 18 72 27 110 9 39 22 93 30 120 8 28
22 77 31 110 20 72 51 160 70 197 8 14 14 34 14 43 0 9 6 29 14 43 7 15 32 65
54 112 170 351 422 670 668 846 174 124 336 191 594 246 97 21 131 23 450 23
259 0 386 -4 510 -17 318 -34 476 -48 535 -48 33 0 101 -7 150 -15 50 -8 126
-15 170 -16 44 0 103 -5 130 -10 28 -5 108 -14 178 -19 70 -5 160 -14 200 -19
40 -6 135 -16 212 -21 77 -6 165 -15 195 -20 30 -4 86 -9 124 -9 37 -1 107 -7
155 -15 47 -8 136 -20 196 -26 61 -7 116 -17 123 -22 17 -15 16 -173 -3 -234
-8 -27 -15 -68 -15 -91 0 -24 -6 -60 -14 -80 -8 -21 -17 -55 -21 -77 -3 -21
-10 -46 -15 -55 -5 -9 -18 -45 -30 -81 -25 -73 -77 -157 -101 -165 -9 -3 -28
-1 -43 5 -15 5 -53 10 -85 10 -32 0 -83 5 -112 11 -30 5 -101 14 -159 19 -58
5 -134 14 -170 19 -36 6 -102 11 -147 11 -45 0 -131 8 -190 17 -230 37 -749
18 -886 -33 -20 -8 -51 -14 -68 -14 -17 0 -40 -5 -52 -12 -12 -6 -38 -15 -57
-19 -97 -21 -278 -107 -413 -196 -127 -84 -296 -252 -359 -355 -53 -87 -74
-133 -123 -258 -20 -52 -50 -127 -66 -167 -16 -39 -29 -82 -29 -95 0 -13 -7
-32 -15 -42 -8 -11 -15 -30 -15 -42 0 -12 -6 -35 -14 -51 -8 -15 -22 -55 -31
-88 -9 -33 -23 -73 -30 -90 -8 -16 -16 -41 -20 -55 -3 -14 -10 -34 -15 -45
-12 -26 -39 -101 -50 -140 -14 -50 -40 -119 -50 -137 -6 -10 -10 -26 -10 -35
-1 -10 -9 -36 -20 -58 -11 -22 -19 -45 -20 -52 0 -7 -7 -29 -16 -50 -9 -21
-23 -51 -29 -68 -52 -123 -115 -232 -173 -296 -53 -59 -147 -133 -182 -144
-14 -4 -29 -11 -35 -15 -36 -25 -244 -80 -307 -80 -23 -1 -70 -7 -103 -15 -35
-9 -113 -15 -185 -15 -69 -1 -147 -6 -175 -11 -27 -5 -115 -14 -195 -19 -80
-5 -203 -16 -275 -25 -71 -8 -155 -15 -186 -15 -31 0 -81 -5 -110 -11 -30 -5
-85 -14 -124 -19 -410 -49 -766 -178 -1112 -401 -147 -95 -148 -96 -348 -250
-164 -127 -555 -502 -555 -531 0 -25 19 -22 63 8 72 48 392 216 592 309 44 21
92 44 107 51 45 24 56 18 62 -28 9 -78 15 -462 7 -542 l-7 -79 -84 -80 c-368
-346 -672 -566 -1020 -737 -168 -84 -349 -158 -435 -179 -17 -4 -40 -13 -52
-19 -12 -7 -34 -12 -48 -12 -14 0 -36 -5 -48 -12 -12 -6 -51 -17 -87 -24 -36
-6 -119 -24 -185 -38 -66 -14 -132 -26 -146 -26 -15 0 -56 -8 -91 -17 -91 -24
-946 -23 -1023 1 -27 9 -67 16 -87 16 -21 0 -57 6 -80 14 -24 7 -68 21 -98 31
-154 47 -249 167 -267 333 -13 115 -6 123 74 94 33 -12 69 -22 79 -22 10 0 31
-6 46 -14 15 -8 41 -17 59 -21 19 -4 40 -11 49 -16 33 -18 187 -53 314 -70
104 -14 908 -7 989 9 31 7 83 17 115 23 128 24 157 31 167 39 6 4 25 11 43 15
51 11 341 140 482 215 34 18 59 45 50 53 -3 3 -57 -4 -120 -14 -79 -13 -220
-22 -450 -30 -292 -10 -366 -9 -575 5 -376 27 -463 35 -541 51 -40 8 -99 15
-131 15 -32 0 -83 7 -113 15 -30 8 -72 15 -93 15 -21 0 -48 5 -60 12 -12 7
-44 15 -72 19 -27 4 -70 13 -95 19 -25 7 -72 19 -105 27 -108 27 -159 49 -172
73 -6 12 -14 75 -17 139 -3 64 -8 153 -11 199 -6 96 3 107 63 77 21 -10 53
-21 72 -26 19 -4 67 -18 105 -31 76 -26 137 -45 255 -78 41 -12 97 -27 124
-35 26 -8 55 -15 64 -15 8 0 38 -6 66 -14 122 -34 245 -56 426 -76 52 -6 138
-16 190 -21 167 -19 507 -2 655 32 241 57 402 147 599 338 170 166 597 621
591 631 -9 15 -26 12 -47 -7 -21 -19 -40 -30 -133 -76 -87 -44 -246 -94 -475
-151 -30 -8 -75 -19 -100 -25 -25 -7 -75 -16 -113 -21 -37 -5 -76 -14 -87 -20
-10 -5 -43 -10 -73 -10 -29 0 -76 -6 -103 -14 -27 -8 -96 -17 -154 -21 -58 -4
-168 -13 -245 -21 -156 -15 -522 -18 -630 -4 -38 5 -124 14 -190 20 -248 23
-559 69 -587 86 -6 4 -28 11 -47 15 -35 8 -79 21 -194 62 -68 24 -74 38 -58
130 6 34 16 240 22 457 5 217 14 420 19 450 5 30 9 93 9 140 1 47 8 123 16
170 8 47 15 108 15 135 0 28 7 77 14 110 8 33 17 89 21 125 3 36 13 95 21 132
8 37 14 87 14 111 0 25 7 64 15 87 8 23 15 58 15 77 0 18 7 50 15 70 8 19 15
55 15 80 0 24 5 54 12 66 6 12 17 51 24 87 25 129 59 285 75 340 28 95 24 92
159 130 187 52 250 68 322 81 26 4 56 12 67 18 11 6 34 11 50 11 17 0 57 6 89
14 31 8 86 19 122 26 114 19 221 39 238 44 21 7 222 36 322 46 41 5 95 13 120
19 25 6 75 11 111 11 36 0 115 7 175 15 171 23 178 25 165 38 -7 7 -81 14
-209 18 -210 7 -362 22 -453 45 -30 8 -73 14 -95 14 -21 1 -50 7 -64 15 -14 8
-37 14 -52 15 -15 0 -45 6 -65 14 -21 8 -69 24 -108 36 -38 11 -79 25 -90 30
-11 5 -45 19 -75 31 -79 31 -450 216 -480 239 -28 21 -31 7 29 160 12 30 31
82 42 115 10 33 23 67 28 75 4 8 28 65 51 125 24 61 50 119 57 130 7 11 13 25
13 32 0 7 14 41 30 75 17 34 30 65 30 69 0 4 16 42 36 86 20 43 47 103 61 133
60 131 140 290 180 358 24 41 43 76 43 79 0 3 39 64 87 137 207 312 341 431
598 526 33 12 76 28 95 36 19 7 62 20 95 30 33 9 78 23 100 30 23 8 53 14 69
14 15 0 42 6 59 14 18 7 57 19 87 25 30 7 82 18 115 26 33 8 85 19 115 26 30
6 78 17 106 25 28 8 66 14 85 14 19 1 52 7 74 15 22 8 54 15 70 15 17 0 46 5
65 11 38 12 163 34 280 50 41 5 103 17 137 25 34 7 83 14 110 14 26 0 80 7
118 15 39 8 107 15 152 15 46 0 125 7 175 16 76 13 147 15 388 11 177 -3 313
-9 340 -17 96 -25 176 -54 205 -74 16 -12 38 -25 49 -31 34 -18 42 -40 28 -87
-7 -24 -17 -60 -23 -81 -5 -21 -13 -45 -18 -55 -5 -9 -25 -71 -46 -137 -21
-66 -44 -135 -51 -153 -8 -18 -14 -40 -14 -48 0 -9 -6 -28 -14 -42 -7 -15 -24
-61 -36 -102 -39 -131 -53 -174 -67 -207 -7 -17 -13 -37 -13 -44 0 -7 -6 -31
-14 -54 -8 -22 -22 -67 -31 -100 -10 -33 -23 -76 -30 -95 -7 -19 -23 -71 -35
-115 -12 -44 -28 -86 -34 -93 -10 -10 -56 -11 -237 -3 -332 16 -455 14 -603
-9 -253 -40 -371 -94 -476 -221 -70 -85 -91 -118 -191 -314 -89 -172 -123
-215 -172 -215 -75 0 -186 -142 -187 -239 -1 -20 -5 -56 -11 -81 -9 -41 -16
-92 -48 -340 -6 -47 -18 -125 -26 -175 -8 -49 -19 -128 -25 -175 -6 -47 -18
-130 -26 -185 -8 -55 -19 -143 -25 -195 -5 -52 -17 -133 -25 -180 -16 -97 -19
-252 -4 -280 19 -35 92 -68 165 -75 84 -7 266 7 315 25 19 7 55 20 80 28 77
25 170 143 170 214 0 13 6 43 14 68 15 46 26 98 51 230 8 41 19 91 25 110 5
19 10 49 10 66 0 17 7 48 15 67 8 20 15 56 15 80 0 25 7 61 15 80 8 20 15 54
15 75 0 22 7 56 15 75 8 20 15 52 15 71 0 19 5 47 11 63 5 15 17 61 24 103 32
166 36 186 50 223 8 20 15 52 15 69 0 17 6 54 14 82 41 146 42 142 -17 162
-50 17 -46 43 15 105 57 58 144 106 238 132 100 28 342 50 463 43 61 -4 119
-12 129 -17 21 -12 23 -44 3 -79 -8 -14 -14 -40 -15 -57 0 -18 -6 -50 -14 -70
-7 -21 -19 -63 -25 -93 -6 -30 -18 -84 -26 -120 -8 -36 -19 -90 -25 -120 -7
-30 -18 -78 -26 -106 -8 -28 -14 -65 -14 -83 0 -17 -7 -48 -15 -68 -8 -19 -15
-49 -15 -66 0 -17 -6 -53 -14 -81 -8 -28 -20 -78 -26 -111 -6 -33 -17 -94 -25
-135 -36 -189 -69 -374 -85 -475 -6 -38 -16 -97 -22 -130 -6 -33 -14 -97 -18
-141 -4 -45 -12 -103 -18 -130 -6 -27 -16 -85 -21 -129 -6 -44 -15 -114 -21
-155 -6 -41 -17 -120 -26 -175 -8 -55 -14 -118 -14 -140 -1 -22 -7 -69 -15
-105 -8 -36 -14 -98 -15 -138 0 -40 -6 -105 -14 -145 -8 -40 -17 -126 -21
-192 -3 -66 -11 -137 -16 -159 -8 -30 -7 -42 3 -52 13 -14 40 -7 253 67 42 15
123 38 170 50 22 5 49 14 60 19 11 5 38 14 61 20 56 14 75 38 74 91 -2 51 18
342 25 379 3 14 10 75 15 135 5 61 14 146 19 190 6 44 18 145 26 225 9 80 23
186 30 235 8 50 23 160 35 245 11 85 27 191 35 235 8 44 15 94 15 111 0 17 7
51 15 74 8 23 15 60 15 82 0 36 10 89 41 213 6 22 15 67 20 100 5 33 14 73 19
90 5 16 13 55 19 85 24 134 65 304 105 437 9 28 16 58 16 66 0 12 13 59 54
197 8 25 21 72 31 105 10 33 23 76 30 95 7 19 18 51 24 70 7 19 18 55 26 80 7
25 24 71 39 104 14 32 26 64 26 71 0 8 6 26 14 42 8 15 29 64 47 108 144 360
347 645 593 833 117 90 155 114 251 161 107 52 136 63 325 115 125 35 569 36
735 2 131 -28 240 -46 315 -52 41 -4 90 -13 109 -20 18 -8 57 -14 86 -14 29 0
72 -7 95 -15 23 -8 66 -15 95 -15 29 0 69 -7 88 -15 20 -8 59 -15 86 -15 27 0
62 -5 78 -11 15 -6 57 -15 93 -19 36 -5 92 -14 125 -20 33 -6 107 -20 165 -31
58 -11 133 -26 167 -34 34 -8 77 -15 96 -15 19 0 54 -7 77 -15 23 -8 56 -15
72 -15 17 0 60 -6 97 -14 82 -18 161 -33 271 -51 96 -16 173 -30 275 -50 39
-8 97 -18 130 -24 33 -6 105 -20 160 -30 55 -11 120 -23 145 -26 25 -4 67 -13
94 -21 27 -8 67 -14 89 -14 21 0 62 -6 90 -14 29 -7 97 -21 152 -30 55 -10
126 -24 157 -32 32 -8 73 -14 92 -14 18 0 53 -7 76 -15 23 -8 60 -15 81 -15
21 0 76 -9 121 -19 46 -11 117 -26 158 -34 41 -9 109 -23 150 -31 41 -9 86
-16 99 -16 13 0 55 -7 95 -15 204 -44 324 -68 406 -80 25 -4 72 -13 105 -20
76 -17 211 -43 250 -49 27 -4 75 -13 320 -62 39 -7 102 -18 140 -24 39 -6 84
-16 100 -22 17 -5 59 -14 95 -19 98 -13 188 -28 257 -44 34 -8 76 -15 94 -15
18 0 58 -6 88 -14 53 -14 120 -27 241 -47 30 -6 75 -15 100 -21 25 -6 68 -14
95 -18 48 -6 113 -18 235 -42 30 -5 75 -13 100 -18 25 -4 74 -13 110 -19 36
-7 97 -19 135 -26 39 -8 126 -24 195 -36 69 -12 148 -28 177 -35 28 -8 67 -14
87 -14 20 0 53 -7 73 -15 19 -8 51 -15 70 -15 19 0 65 -6 102 -14 36 -8 98
-20 136 -26 39 -7 104 -18 145 -25 41 -8 107 -19 145 -25 39 -7 95 -18 126
-26 30 -8 66 -14 80 -14 13 0 53 -6 89 -14 36 -8 92 -20 125 -26 33 -7 89 -18
125 -25 36 -7 92 -18 125 -25 33 -6 92 -18 130 -26 39 -8 84 -14 100 -14 17 0
46 -5 65 -11 19 -6 62 -14 95 -19 66 -9 156 -25 225 -42 25 -6 70 -14 102 -18
31 -4 60 -10 65 -13 5 -3 49 -13 99 -21 49 -9 114 -21 144 -27 99 -19 194 -37
250 -49 30 -6 80 -15 110 -19 30 -4 75 -13 100 -19 25 -6 74 -16 110 -22 36
-6 97 -18 135 -26 39 -7 99 -19 135 -25 36 -6 73 -15 83 -21 10 -5 50 -13 90
-18 40 -5 90 -14 112 -19 62 -15 169 -35 380 -71 39 -7 92 -18 119 -26 26 -8
60 -14 75 -14 14 0 58 -7 96 -16 126 -28 198 -43 300 -60 55 -9 127 -23 160
-32 33 -8 87 -18 120 -21 33 -4 70 -12 82 -19 12 -7 39 -12 61 -12 22 0 56 -7
75 -15 20 -8 55 -15 77 -15 22 0 57 -7 77 -15 19 -8 52 -15 72 -15 20 0 63 -7
94 -15 32 -8 71 -15 87 -15 16 0 47 -6 67 -14 21 -8 61 -17 88 -20 28 -4 68
-13 90 -21 22 -8 57 -14 78 -15 21 0 48 -5 60 -12 12 -7 45 -15 72 -19 28 -3
64 -11 80 -17 30 -11 93 -24 220 -47 39 -7 83 -17 98 -24 16 -6 46 -11 68 -11
22 0 51 -7 64 -16 18 -12 35 -14 62 -9 35 6 37 8 18 21 -10 8 -27 14 -38 14
-11 0 -42 7 -71 16 -28 9 -71 22 -96 30 -25 8 -56 14 -70 14 -14 1 -36 7 -50
15 -14 8 -38 14 -53 15 -16 0 -38 5 -49 11 -12 7 -48 18 -80 25 -32 8 -84 20
-116 28 -32 7 -68 18 -80 25 -11 6 -36 11 -54 11 -18 1 -44 7 -58 15 -14 8
-38 15 -55 15 -16 0 -41 7 -55 15 -14 8 -39 14 -56 15 -17 0 -48 7 -67 15 -20
8 -48 15 -61 15 -14 0 -40 6 -58 14 -29 12 -80 26 -288 77 -25 6 -67 17 -95
24 -27 7 -72 18 -100 25 -27 6 -77 17 -110 25 -33 7 -89 20 -125 29 -123 28
-180 43 -315 80 -27 8 -72 20 -100 26 -27 7 -77 19 -110 27 -33 8 -85 20 -115
28 -30 7 -68 18 -83 24 -16 6 -39 11 -53 11 -13 0 -32 4 -42 9 -9 4 -60 18
-112 30 -52 12 -113 27 -135 33 -22 6 -65 16 -95 24 -30 7 -84 20 -120 29 -36
9 -87 21 -115 27 -27 5 -65 16 -83 24 -18 8 -47 14 -65 14 -18 1 -43 7 -57 15
-14 8 -41 14 -61 15 -20 0 -50 7 -65 15 -16 8 -41 15 -56 15 -15 0 -47 6 -70
14 -24 8 -61 17 -83 21 -22 3 -62 13 -90 21 -27 9 -75 22 -105 30 -30 9 -77
22 -105 30 -27 7 -79 21 -115 29 -36 9 -87 22 -115 29 -27 8 -93 24 -145 36
-52 12 -117 28 -145 35 -154 39 -184 47 -226 60 -26 8 -57 15 -71 15 -13 0
-49 9 -81 20 -31 11 -69 20 -84 20 -16 1 -39 7 -53 15 -14 8 -43 15 -65 15
-22 0 -51 7 -65 15 -14 8 -41 15 -60 15 -19 0 -46 7 -60 15 -14 8 -36 14 -49
15 -13 0 -44 6 -70 14 -25 8 -68 20 -96 26 -169 40 -234 57 -295 76 -25 8 -58
14 -75 14 -16 1 -41 7 -55 15 -14 8 -43 15 -65 15 -22 0 -51 7 -65 15 -14 8
-39 14 -57 15 -17 0 -44 5 -60 11 -15 6 -56 18 -90 25 -158 35 -191 42 -238
54 -27 7 -72 18 -100 25 -27 7 -70 19 -95 25 -25 6 -72 18 -105 26 -33 9 -87
22 -120 31 -33 8 -89 21 -125 28 -72 15 -130 30 -204 51 -26 8 -57 14 -68 14
-11 0 -41 6 -67 14 -79 25 -154 44 -201 51 -25 4 -53 12 -64 17 -10 6 -42 14
-70 18 -53 9 -110 22 -206 45 -69 17 -143 34 -195 44 -22 5 -60 13 -85 19 -25
7 -63 16 -85 21 -22 5 -71 18 -110 29 -38 11 -115 29 -170 42 -55 12 -122 28
-150 35 -70 19 -141 34 -204 46 -29 5 -61 14 -71 19 -10 5 -42 14 -71 19 -85
16 -217 47 -324 76 -27 8 -93 24 -145 35 -52 12 -115 28 -140 36 -25 8 -57 14
-71 14 -15 0 -40 7 -55 15 -16 8 -49 15 -74 15 -26 0 -51 5 -58 12 -7 7 -36
15 -64 19 -51 7 -86 15 -193 44 -60 16 -322 80 -420 102 -38 8 -92 21 -120 28
-27 7 -72 18 -100 25 -27 6 -77 18 -110 26 -33 8 -82 20 -110 25 -27 6 -92 22
-145 36 -52 14 -113 29 -135 33 -22 3 -56 11 -75 17 -55 18 -148 40 -315 77
-33 8 -73 19 -88 25 -16 6 -41 11 -56 11 -16 0 -45 7 -64 15 -20 8 -48 15 -63
15 -14 0 -47 7 -73 15 -50 16 -219 58 -316 79 -88 19 -155 37 -198 52 -20 8
-53 14 -73 14 -19 0 -45 5 -56 11 -11 6 -44 15 -72 19 -48 7 -78 14 -206 46
-30 7 -98 23 -150 35 -52 11 -120 26 -150 34 -30 7 -77 18 -105 25 -27 7 -84
19 -125 27 -41 8 -104 20 -140 28 -36 7 -90 19 -120 25 -30 6 -85 17 -121 25
-37 8 -75 15 -85 15 -11 0 -37 7 -59 15 -22 8 -59 14 -82 15 -23 0 -54 5 -70
11 -15 6 -55 15 -88 20 -33 5 -89 16 -125 23 -79 17 -221 43 -315 58 -62 10
-985 21 -1025 13z m6103 -2640 c32 -8 93 -15 135 -15 42 0 99 -7 126 -15 27
-8 86 -15 130 -15 45 -1 108 -7 141 -15 33 -8 101 -15 150 -15 50 0 112 -7
139 -15 27 -8 76 -15 109 -15 33 0 105 -7 161 -15 55 -8 146 -19 201 -25 55
-5 116 -14 135 -20 19 -5 64 -10 100 -10 36 0 90 -7 120 -15 30 -8 89 -15 130
-15 41 0 104 -7 140 -15 36 -8 97 -15 135 -15 39 -1 88 -7 110 -15 22 -8 69
-15 105 -15 36 -1 88 -6 115 -11 28 -5 93 -14 145 -19 125 -12 331 -38 401
-50 30 -6 67 -10 81 -10 36 0 44 -15 57 -95 6 -38 15 -86 21 -105 5 -19 10
-53 10 -76 0 -23 7 -61 15 -84 8 -23 15 -66 15 -94 0 -28 5 -69 10 -91 11 -42
37 -207 47 -286 6 -54 -6 -64 -59 -48 -18 5 -62 9 -98 9 -36 0 -92 7 -125 15
-33 8 -98 15 -145 15 -47 0 -116 7 -155 15 -38 8 -106 15 -150 16 -44 0 -102
4 -130 10 -27 5 -106 14 -175 19 -69 5 -141 14 -160 20 -19 5 -60 10 -91 10
-31 0 -94 7 -140 15 -46 8 -144 19 -216 25 -73 6 -156 15 -184 20 -29 6 -74
10 -101 10 -27 0 -93 6 -146 14 -53 8 -155 20 -227 26 -71 7 -184 18 -250 26
-66 7 -159 18 -207 23 -51 6 -99 17 -115 28 -102 64 -214 193 -277 319 -50
101 -76 161 -76 176 0 7 -7 22 -15 32 -8 11 -15 34 -15 51 0 17 -7 40 -15 51
-8 10 -15 35 -15 55 0 20 -7 56 -15 79 -15 43 -21 151 -8 163 11 11 66 8 126
-8z"/>
<path d="M8670 23097 c-42 -12 -103 -35 -135 -52 -68 -34 -165 -126 -195 -185
-27 -52 -80 -218 -80 -248 0 -13 -7 -50 -15 -81 -8 -31 -19 -86 -25 -122 -5
-35 -14 -89 -20 -119 -6 -30 -17 -93 -26 -140 -32 -177 -46 -254 -84 -445 -7
-33 -16 -88 -20 -121 -4 -34 -10 -66 -14 -72 -4 -7 -13 -51 -21 -99 -18 -110
-32 -181 -51 -260 -8 -34 -14 -75 -14 -92 0 -18 -7 -48 -15 -68 -9 -21 -15
-67 -15 -114 0 -78 0 -80 32 -99 48 -29 158 -44 278 -36 97 6 111 9 196 51 96
47 164 108 164 149 1 12 7 32 15 46 8 14 14 36 15 49 0 13 7 44 15 70 8 25 24
84 36 131 11 47 27 108 34 135 24 88 37 149 47 204 5 29 13 62 18 72 6 10 10
29 10 43 0 14 7 46 16 72 8 25 20 67 24 93 5 25 16 73 24 106 8 33 20 80 26
105 6 25 18 66 26 91 8 26 14 59 14 73 0 15 7 43 15 63 8 19 15 63 15 96 l0
60 -57 54 -58 54 24 17 c35 24 137 51 195 52 101 0 244 -32 446 -102 176 -61
189 -61 190 3 0 14 5 30 11 36 6 6 14 26 19 44 9 39 27 90 46 136 7 18 16 54
20 82 6 49 6 50 -22 56 -16 3 -42 10 -59 16 -58 20 -141 47 -215 69 -41 12
-86 27 -100 32 -28 11 -103 32 -195 55 -55 13 -96 21 -280 53 -89 15 -171 11
-255 -13z"/>
<path d="M26211 22721 c-12 -8 -9 -11 12 -16 15 -4 35 -4 44 -1 15 6 15 8 3
16 -19 12 -41 12 -59 1z"/>
<path d="M18549 21706 c-2 -3 -39 -14 -82 -25 -218 -59 -400 -192 -506 -371
-23 -38 -41 -71 -41 -73 0 -4 -49 -114 -81 -182 -5 -11 -13 -33 -18 -50 -5
-16 -19 -55 -31 -85 -12 -30 -25 -68 -30 -85 -13 -48 -31 -98 -46 -128 -8 -16
-14 -39 -14 -51 0 -12 -5 -27 -10 -32 -11 -11 -46 -98 -60 -149 -9 -33 -27
-87 -43 -125 -5 -14 -13 -41 -18 -60 -8 -38 -62 -197 -101 -301 -32 -84 -52
-142 -143 -419 -9 -28 -15 -82 -15 -140 1 -78 5 -103 23 -140 37 -75 59 -102
107 -132 82 -52 153 -66 385 -72 116 -3 363 -10 550 -17 689 -23 9222 2 10440
31 248 6 756 15 1130 21 374 5 797 13 940 19 143 5 414 9 602 9 188 1 344 5
347 10 3 5 0 14 -7 19 -9 8 -1960 12 -6718 15 -4601 3 -6801 8 -7014 15 -356
13 -339 8 -393 113 -37 73 -37 103 -3 189 13 30 33 84 46 120 13 36 34 90 45
120 11 30 30 82 41 115 19 54 56 149 79 200 12 28 74 189 95 250 9 28 23 64
30 80 12 28 28 70 62 160 69 186 135 320 205 422 59 85 197 221 252 247 69 33
175 66 210 66 18 0 71 7 117 15 70 12 134 12 379 4 162 -5 437 -14 610 -19
173 -5 369 -14 435 -20 66 -5 190 -10 275 -10 85 -1 216 -5 290 -10 74 -6 288
-14 475 -19 187 -5 432 -14 545 -20 113 -6 329 -16 480 -22 151 -6 322 -14
380 -19 58 -5 211 -9 340 -10 129 0 273 -5 320 -10 47 -6 249 -15 450 -21 201
-5 415 -14 475 -19 61 -5 193 -9 295 -10 102 0 239 -5 305 -11 66 -5 282 -14
480 -19 198 -5 464 -14 590 -19 127 -5 403 -15 615 -21 1144 -32 1441 -41
1599 -50 95 -6 343 -11 550 -11 207 -1 459 -5 561 -10 173 -7 1211 -22 2140
-30 400 -4 405 -4 405 16 0 19 -9 20 -310 27 -170 3 -375 11 -455 17 -80 7
-255 16 -390 22 -135 5 -326 14 -425 19 -99 5 -254 9 -345 10 -91 0 -232 7
-315 15 -82 8 -204 15 -270 15 -66 0 -192 7 -280 15 -88 8 -205 15 -260 15
-55 0 -154 7 -220 15 -66 8 -163 15 -215 15 -52 0 -151 5 -220 11 -69 5 -206
14 -305 19 -99 5 -220 14 -270 19 -49 6 -187 15 -305 21 -118 6 -235 15 -260
20 -25 5 -85 9 -135 10 -49 0 -151 7 -225 15 -74 8 -171 15 -215 15 -44 0
-129 7 -190 15 -60 8 -159 15 -220 16 -60 0 -146 4 -190 9 -44 5 -181 16 -305
24 -124 9 -268 20 -320 26 -52 5 -135 10 -185 10 -49 0 -109 5 -133 10 -24 6
-141 15 -260 20 -119 6 -262 15 -317 20 -55 5 -141 9 -191 10 -50 0 -115 5
-144 10 -29 6 -159 15 -289 20 -130 6 -267 15 -306 20 -38 6 -160 15 -270 21
-110 5 -236 14 -280 19 -44 5 -134 9 -200 9 -67 1 -175 8 -240 16 -66 8 -172
15 -235 15 -63 0 -149 5 -190 11 -41 6 -165 14 -275 19 -110 4 -281 13 -380
19 -304 19 -532 32 -725 41 -175 8 -461 24 -950 52 -212 12 -1101 23 -1111 14z"/>
<path d="M14297 18825 c-6 -40 8 -63 41 -71 149 -32 186 -47 225 -94 53 -62
52 -50 51 -976 -2 -881 -6 -988 -41 -1026 -38 -43 -156 -92 -238 -100 -28 -3
-30 -6 -36 -53 -3 -28 -2 -56 4 -62 7 -10 140 -13 604 -13 466 0 595 3 598 13
3 6 1 34 -3 62 -8 55 6 47 -139 76 -47 9 -71 20 -96 44 -68 66 -67 56 -67 532
0 235 4 433 8 438 4 6 220 11 604 12 l598 2 5 -22 c3 -12 5 -215 3 -452 l-3
-430 -27 -42 c-33 -50 -118 -103 -166 -103 -62 0 -118 -86 -78 -119 9 -8 178
-11 594 -11 654 1 597 -7 584 80 l-7 45 -65 7 c-36 3 -82 13 -102 22 -51 22
-105 78 -118 123 -8 27 -10 312 -8 953 l3 915 22 41 c36 67 87 109 156 128 34
10 73 20 87 24 21 6 26 14 28 47 l3 40 -588 -1 -588 -1 0 -39 c0 -42 -4 -39
92 -63 65 -17 135 -70 160 -121 22 -44 23 -52 23 -410 0 -272 -3 -369 -12
-378 -19 -19 -1181 -17 -1197 2 -9 10 -11 113 -9 377 l3 364 34 51 c49 74 72
87 231 132 21 6 25 13 25 47 l0 40 -597 0 -596 0 -5 -30z"/>
<path d="M22469 18849 c-6 -3 -9 -37 -7 -75 l3 -69 50 -7 c61 -7 112 -29 146
-62 46 -43 49 -101 49 -1019 -1 -919 -1 -931 -56 -988 -24 -26 -55 -38 -181
-75 -8 -2 -13 -21 -13 -48 0 -85 -80 -78 768 -75 855 2 785 -5 797 86 3 26 10
75 16 108 10 59 30 286 33 375 l1 45 -94 3 c-108 3 -111 1 -111 -71 0 -77 -52
-188 -119 -257 -77 -79 -129 -100 -244 -100 -111 0 -164 22 -211 90 l-31 45 0
912 0 911 31 39 c37 45 105 82 156 82 20 1 44 8 52 17 20 19 22 119 4 130 -15
9 -1025 12 -1039 3z"/>
<path d="M29170 18714 c-146 -25 -246 -37 -365 -41 -174 -6 -167 -2 -163 -71
l3 -57 50 -6 c82 -9 119 -33 144 -94 l22 -53 -4 -839 c-4 -887 -4 -891 -50
-941 -28 -30 -69 -52 -99 -52 -42 0 -68 -27 -68 -70 0 -21 5 -42 11 -46 18
-11 969 -8 980 3 6 6 9 32 7 59 -3 44 -6 49 -28 52 -47 6 -145 43 -185 71 -35
24 -41 33 -48 81 -5 30 -7 163 -4 295 4 257 7 273 56 295 22 10 29 6 89 -52
35 -35 121 -137 190 -228 69 -91 132 -171 139 -178 7 -8 34 -44 60 -80 26 -37
74 -103 108 -147 33 -44 73 -99 88 -122 21 -33 35 -44 63 -49 20 -4 187 -3
372 1 404 9 631 10 772 4 l105 -4 0 55 0 55 -45 6 c-25 4 -58 12 -73 18 -16 6
-40 11 -55 11 -32 0 -87 37 -101 68 -17 35 -13 108 7 155 10 23 27 62 37 87
34 80 62 118 97 129 22 7 120 9 287 6 140 -3 262 -5 272 -5 20 0 68 -76 108
-170 13 -30 32 -74 42 -98 42 -94 10 -149 -105 -182 -38 -11 -73 -25 -78 -32
-4 -7 -7 -29 -6 -48 l3 -35 482 -3 483 -2 6 25 c3 14 3 41 0 60 -6 32 -10 34
-54 40 -136 18 -127 6 -363 484 -111 223 -297 597 -413 831 l-211 425 -39 0
-40 0 -55 -121 c-31 -66 -69 -149 -85 -185 -16 -35 -49 -107 -74 -159 -24 -52
-53 -115 -64 -140 -10 -25 -25 -58 -33 -75 -69 -151 -85 -186 -85 -192 0 -3
-12 -31 -26 -62 -14 -31 -35 -76 -46 -101 -11 -25 -30 -67 -43 -95 -13 -27
-35 -77 -50 -110 -14 -33 -32 -73 -40 -90 -20 -44 -40 -91 -75 -176 -65 -161
-137 -239 -219 -239 -33 0 -93 49 -165 135 -53 64 -237 279 -448 523 -67 79
-144 169 -170 200 -27 32 -73 85 -103 120 -54 62 -62 77 -47 97 4 6 52 46 107
90 55 43 122 100 150 125 234 208 302 259 353 260 13 0 33 6 45 12 12 7 54 15
92 18 l70 5 0 55 0 55 -409 3 c-301 2 -412 -1 -423 -10 -9 -7 -13 -27 -11 -57
l3 -46 66 -6 c66 -5 123 -29 142 -60 24 -39 -2 -72 -236 -303 -332 -326 -370
-356 -397 -307 -6 13 -8 154 -6 413 8 698 8 806 2 817 -9 14 -111 12 -206 -5z
m2437 -1114 c42 -98 88 -200 119 -262 8 -14 14 -31 14 -37 0 -5 14 -30 31 -56
55 -81 57 -80 -211 -82 -134 -2 -241 1 -250 7 -18 11 -9 41 61 188 27 57 49
108 49 114 0 5 6 22 14 36 14 28 41 88 72 160 29 69 49 56 101 -68z"/>
<path d="M25077 18308 c-13 -13 -34 -48 -47 -78 -12 -30 -36 -84 -52 -120 -16
-36 -33 -74 -38 -85 -4 -11 -37 -81 -73 -155 -68 -142 -105 -222 -182 -395 -7
-16 -27 -59 -43 -95 -17 -36 -42 -94 -57 -130 -15 -36 -37 -87 -50 -115 -13
-27 -32 -70 -43 -95 -113 -255 -182 -380 -231 -425 -13 -11 -46 -29 -74 -40
l-52 -21 -3 -51 c-3 -44 0 -53 18 -63 12 -6 33 -9 48 -6 63 12 508 18 549 7
22 -6 48 -8 57 -5 18 7 37 65 29 93 -6 23 -5 22 -118 46 -94 20 -126 35 -154
71 -31 40 -26 91 20 207 71 181 62 177 422 177 l284 0 47 -97 c26 -54 53 -109
60 -123 23 -44 38 -124 28 -150 -13 -34 -44 -60 -84 -70 -18 -5 -49 -14 -68
-21 -19 -6 -41 -14 -48 -15 -9 -3 -12 -19 -10 -51 l3 -48 475 -3 474 -2 24 25
c12 14 25 25 28 25 3 0 11 -14 18 -31 l13 -30 336 -3 c186 -1 342 1 347 4 17
10 24 78 11 94 -11 13 -134 56 -160 56 -25 0 -89 52 -107 88 -18 35 -19 66
-21 586 -1 343 2 556 8 568 9 17 49 26 49 11 0 -5 64 -73 141 -153 78 -79 173
-181 212 -225 78 -89 438 -473 647 -690 75 -77 176 -184 226 -239 84 -91 94
-98 135 -103 33 -4 48 -1 58 10 10 12 13 178 16 764 3 411 7 768 11 793 12 89
78 151 179 165 61 9 75 19 75 56 0 15 -6 31 -12 36 -7 4 -166 6 -353 5 -187
-1 -346 -2 -353 -2 -9 0 -12 -13 -10 -47 3 -42 7 -50 32 -62 16 -7 59 -17 96
-21 83 -9 105 -21 130 -70 19 -37 20 -59 20 -453 0 -363 -2 -416 -16 -427 -18
-15 -2 -30 -165 150 -62 69 -154 170 -205 225 -51 55 -125 139 -165 186 -41
48 -144 163 -229 257 -85 93 -173 191 -195 217 l-40 47 -310 2 c-170 1 -318 5
-327 10 -29 13 -58 -26 -54 -74 5 -55 20 -70 72 -70 60 0 86 -15 112 -64 41
-77 45 -148 39 -671 -7 -536 -15 -656 -50 -725 -45 -92 -178 -142 -260 -100
-21 11 -45 20 -53 20 -9 0 -38 12 -66 27 -63 34 -88 74 -227 363 -22 47 -52
105 -65 130 -14 25 -73 142 -131 260 -57 118 -123 249 -144 290 -52 98 -250
500 -281 570 -28 65 -57 100 -81 100 -10 0 -29 -10 -42 -22z m-87 -623 c0 -15
29 -82 105 -242 30 -63 55 -117 55 -120 0 -2 14 -32 30 -65 53 -106 62 -102
-205 -99 -284 3 -277 -1 -220 126 12 28 35 79 50 115 15 36 40 92 55 125 15
33 38 85 50 115 27 64 47 85 67 69 7 -6 13 -17 13 -24z"/>
<path d="M17472 18261 c-17 -17 -8 -80 14 -97 8 -7 42 -18 76 -25 47 -11 65
-20 83 -44 50 -67 50 -65 50 -765 0 -602 -1 -658 -17 -682 -21 -31 -130 -88
-170 -88 -38 0 -55 -36 -42 -88 l9 -37 460 0 460 0 3 58 c2 41 -1 58 -10 61
-64 17 -137 42 -155 53 -13 7 -31 30 -40 51 -17 34 -18 92 -21 697 l-2 660 23
45 c23 42 29 47 98 68 126 40 120 35 117 93 l-3 51 -459 2 c-383 1 -462 -1
-474 -13z"/>
<path d="M18627 18274 c-4 -4 -7 -31 -7 -59 0 -47 3 -53 27 -64 15 -7 58 -15
96 -18 78 -7 86 -14 112 -99 12 -41 15 -144 15 -649 -1 -607 -4 -667 -39 -732
-14 -27 -67 -59 -111 -67 -19 -3 -50 -15 -67 -26 -27 -16 -33 -26 -33 -54 0
-18 7 -39 15 -46 20 -17 862 -15 883 2 8 7 12 27 10 51 -3 40 -4 41 -68 67
-49 20 -73 37 -98 69 l-32 43 2 301 3 302 88 -1 c80 -1 92 -3 130 -30 23 -17
49 -43 57 -60 8 -17 26 -46 40 -64 14 -19 30 -42 35 -52 6 -9 73 -122 150
-249 77 -128 156 -261 176 -296 19 -35 40 -68 47 -75 7 -7 90 -11 264 -10 139
0 259 1 266 1 21 2 15 69 -9 89 -117 96 -251 266 -335 422 -10 19 -46 78 -79
130 -34 52 -70 109 -80 125 -10 17 -43 56 -73 87 -32 34 -51 62 -47 69 4 6 28
20 54 32 50 22 153 90 192 128 32 31 71 93 92 147 22 55 23 205 2 246 -8 15
-15 34 -15 40 0 20 -86 131 -126 163 -75 59 -141 89 -269 121 -49 12 -169 16
-660 19 -331 2 -604 1 -608 -3z m1059 -171 c53 -28 99 -81 130 -150 23 -50 25
-63 21 -171 -6 -182 -37 -241 -162 -304 -87 -44 -313 -62 -336 -27 -11 17 -12
663 -1 673 4 4 75 6 157 4 129 -3 156 -7 191 -25z"/>
<path d="M20747 18273 c-4 -3 -7 -30 -7 -58 0 -48 2 -53 28 -63 15 -6 44 -13
65 -17 43 -7 82 -44 99 -95 9 -25 13 -213 16 -655 3 -641 -1 -737 -36 -768
-15 -14 -74 -39 -127 -54 -11 -3 -26 -10 -32 -16 -16 -12 -17 -59 -1 -75 9 -9
177 -12 697 -12 l684 0 36 39 c44 48 131 219 131 259 0 9 7 31 16 47 9 17 17
50 17 75 l2 45 -75 0 -75 0 -65 -107 c-83 -137 -118 -173 -204 -204 -61 -22
-82 -24 -229 -24 -181 0 -188 2 -229 67 -23 37 -23 44 -26 332 -3 235 -1 296
10 302 15 10 275 12 330 3 50 -9 76 -50 84 -135 4 -35 11 -70 17 -76 11 -15
123 -18 132 -4 8 14 9 596 1 610 -9 14 -137 3 -148 -13 -4 -6 -8 -28 -8 -48 0
-49 -33 -102 -75 -122 -28 -14 -63 -16 -187 -14 l-153 3 -3 301 c-2 271 -1
303 14 315 26 21 360 15 429 -8 92 -30 205 -163 205 -240 0 -27 5 -29 75 -37
70 -8 92 8 77 55 -6 19 -12 112 -14 207 -3 140 -6 175 -18 182 -17 11 -1443
14 -1453 3z"/>
</g>
</svg>

          </a>
          <div className="flex md:order-2 space-x-3 md:space-x-0 rtl:space-x-reverse gap-2">
            <UserSidebar />
          </div>
        </div>
      </nav>
    </div>
  );
}

export default Navbar;
